<template>
    <div>

        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
            <el-form-item>
                <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
            </el-form-item>

            <el-form-item>
<!--                <el-button type="primary" @click="getList">查询</el-button>-->
                <el-button type="success" @click="handleAddType">新增类型</el-button>
                <el-button type="success" @click="handleAdd">新增配置</el-button>
            </el-form-item>
        </el-form>
      <el-container style="border: 1px solid #eee">
      <el-aside width="200px" style="overflow:scroll;">
<!--          <el-select v-model="formInline.dictionaryTypeId" filterable>-->
<!--            <el-option-->
<!--                v-for="item in getDictionaryTypeList"-->
<!--                :key="item.dictionaryTypeId"-->
<!--                :label="item.typeName"-->
<!--                :value="item.dictionaryTypeId">-->
<!--            </el-option>-->
<!--          </el-select>-->
        <el-tree
            style="height: 450px"
            :data="getDictionaryTypeList"
            @node-click="handleNodeClick"
            node-key="dictionaryTypeId"
            :highlight-current='true'
            :default-checked-keys="[0]"
            :props="defaultProps">

        </el-tree>
      </el-aside>
        <el-table :data="getDictionaryList"   border center :size="GCONFIG.styleTableSize"  v-loading="loading" >
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="dictionaryKey" label="配置KEY" sortable></el-table-column>
            <el-table-column prop="dictionaryName" label="配置内容" sortable></el-table-column>
            <el-table-column prop="status" :formatter="convertStatus" label="状态" sortable></el-table-column>
            <el-table-column prop="platformGroupName" label="所属公司" sortable></el-table-column>
            <el-table-column prop="sort" label="排序" sortable></el-table-column>
            <el-table-column prop="remark" label="备注" ></el-table-column>
            <el-table-column label="操作" fixed="right" width="150">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="handleEdit(scope.row)">修改</el-button>
                     <el-button type="warning " size="mini" v-if="scope.row.status=='1'" @click="deleteDictionary(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
      </el-container>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="新增分类" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="120px">
                <el-form-item label="分组类型">
                    <el-select v-model="form.dictionaryTypeId" filterable  clearable >
                        <el-option
                                v-for="item in getDictionaryTypeList"
                                :key="item.dictionaryTypeId"
                                :label="item.typeName"
                                :value="item.dictionaryTypeId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="配置KEY" :required="true">
                    <el-input v-model="form.dictionaryKey" placeholder="配置KEY"></el-input>
                </el-form-item>
                <el-form-item label="配置名称" :required="true">
                    <el-input v-model="form.dictionaryName" placeholder="配置名称"></el-input>
                </el-form-item>
                <el-form-item label="状态">
                  <el-select v-model="form.status" >
                    <el-option
                        v-for="item in statusList"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="配置排序" :required="true">
                    <el-input-number v-model="form.sort" :min="1" :max="1000" :step="1" placeholder="数字"></el-input-number>
                </el-form-item>
                <el-form-item label="配置备注">
                    <el-input v-model="form.remark" placeholder="备注"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateOrSaveDictionary(form)">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="新增分组" :visible.sync="dialogFormVisibleType" center>
            <el-form :model="formType" label-width="120px">
                <el-form-item label="分类标示" >
                    <el-input v-model="formType.dictionaryTypeId" placeholder="必须数字 不能重复"></el-input>
                </el-form-item>
                <el-form-item label="分类名称" >
                    <el-input v-model="formType.typeName" placeholder="分类名称"></el-input>
                </el-form-item>
                <el-form-item label="分类描述">
                    <el-input v-model="formType.remark" placeholder="分类描述"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisibleType = false">取 消</el-button>
                <el-button type="primary" @click="saveDictionaryType(formType)">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getDictionaryTypeList,getValidDictionaryList,updateOrSaveDictionary,saveDictionaryType,deleteDictionary} from '../../api/api'
    import ElForm from "../../../node_modules/element-ui/packages/form/src/form";

    //定义组件
    export default{
        components: {ElForm}, data(){
            return {
                getDictionaryList:[],
                loading:true,
                getDictionaryTypeList: [],
                statusList: [{value: 1, name: '可用'}, {value: 0, name: '不可用'}],
                selectValue: '',
                dialogFormVisibleType:false,
                dialogFormVisible:false,
                formType:{
                    "typeName":"",
                    "remark":"",
                    "dictionaryTypeId":""
                },
                form:{
                    "dictionaryId":"",
                    "dictionaryTypeId":"",
                    "dictionaryKey":"",
                    "dictionaryName":"",
                    "sort":"",
                    "remark":"",
                    "status":1
                },
                formInline:{
                    "dictionaryTypeId":"",
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
              defaultProps:{
                  label:"typeName"
              }
            }
        },
        //挂载时候执行
        mounted(){
            //获取查询条件下拉列表
            getDictionaryTypeList({}).then((res) => {
                this.getDictionaryTypeList = res.data;
                this.formInline.dictionaryTypeId=this.getDictionaryTypeList[0].dictionaryTypeId;
                this.getList();
            })
        },
        methods:{
            //定义查询方法
            getList(){
                this.loading = true;
                getValidDictionaryList(this.formInline).then((res) => {
                    this.loading = false;
                    if(res.data.status==200){
                        // this.$message({
                        //     showClose: true,
                        //     message: '成功',
                        //     type: 'success'
                        // });
                        this.getDictionaryList = res.data.value.list;
                        this.formInline.recordsTotal = res.data.value.total;
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleAddType(){
                this.dialogFormVisibleType = true;
            },
            handleAdd(){
                this.dialogFormVisible = true;
                this.form={
                    "dictionaryId":"",
                    "dictionaryTypeId":"",
                    "dictionaryKey":"",
                    "dictionaryName":"",
                    "sort":"",
                    "remark":"",
                    "status":1
                };
                this.form.dictionaryTypeId=this.formInline.dictionaryTypeId;
            },
            handleEdit(row){
                this.dialogFormVisible = true;
                this.form.dictionaryId=row.dictionaryId;
                this.form.dictionaryTypeId=row.dictionaryTypeId;
                this.form.dictionaryKey=row.dictionaryKey;
                this.form.dictionaryName=row.dictionaryName;
                this.form.sort=row.sort;
                this.form.remark=row.remark;
                this.form.status=row.status;
            },
            deleteDictionary(row){
                this.$confirm('删除配置, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const loading = this.$loading(this.GCONFIG.loadingParam);
                    deleteDictionary({dictionaryId:row.dictionaryId}).then((res) => {
                        loading.close();
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList();
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {});

            },
            saveDictionaryType(formType){
                const loading = this.$loading(this.GCONFIG.loadingParam);
                saveDictionaryType(formType).then((res) => {
                    loading.close();
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.dialogFormVisibleType = false;
                        getDictionaryTypeList({}).then((res) => {
                            this.getDictionaryTypeList = res.data;
                        })
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            updateOrSaveDictionary(form){
                const loading = this.$loading(this.GCONFIG.loadingParam);
                updateOrSaveDictionary(form).then((res) => {
                    loading.close();
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.dialogFormVisible = false;
                        this.getList();
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            convertStatus(row, column, cellValue) {
                if (row.status == 1) {
                    return "有效";
                } else {
                    return "无效";
                }
            },
            returnHistory(){
                window.history.back()
            },
          handleNodeClick(data){
              console.log(data.dictionaryTypeId);
            this.formInline.dictionaryTypeId=data.dictionaryTypeId;
            this.getList();
          }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/dictionary/dictionary.vue